import { Prop, Vue, Watch } from 'vue-property-decorator';

// import style from "./style.vue";
import Component from 'vue-class-component';
import Product from './product.vue';
import IPSDialog from '@/views/components/picker/dialog';
import DialogFactory from '@/views/components/picker/dialogFactory';

@DialogFactory
@Component({
  components: {
    'product-item': Product,
  },
  mixins: [],
})
export default class BindGoods extends IPSDialog {
  title = '绑定商品';

  width = '500px';

  // 选中的商品
  productCode = '';

  select = 0;
  goodsList = [];

  mounted() {
    this.goodsList.forEach((v, i) => {
      if (v.productCode === this.productCode) {
        this.select = i;
      }
    });
  }

  getResults(): {} {
    return this.goodsList[this.select];
  }

  renderContent(h) {
    return (
      <div class="select-goods" style="min-height:200px">
        {this.goodsList.length ? (
          <ul>
            {this.goodsList.map((i, index) => {
              return (
                <li class="goods-item flex items-center r-pa-10">
                  <el-radio v-model={this.select} label={index} class="r-mr-0 text-white">
                    &nbsp;
                  </el-radio>
                  <product-item product={i} class="wid-155" />
                  <div class="right wid-50 flex-s-0 fr">
                    <el-checkbox v-model={i.mark} disabled={true}>
                      {i.mark ? '已标注' : '未标注'}
                    </el-checkbox>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          <div class="no-data">请先选择相关商品</div>
        )}
      </div>
    );
  }
}
